import React from 'react';
import {
  FileText, Image, Shield, Pencil, Zap, Layers, ArrowRightCircle, ArrowLeftCircle,
  Scissors, Trash2, FileOutput, LayoutGrid, ScanLine, Minimize2, Wrench, Eye,
  Square, FileType, Table, Presentation, Globe, Type, Sheet, Monitor, Archive,
  AlignLeft, PenTool, RotateCcw, Hash, Droplets, Crop, MessageSquare, PenLine,
  Unlock, Lock, EyeOff, GitCompare, Eraser, Maximize2, Minimize, RefreshCw,
  Sparkles, FolderPlus, Mail, Cloud, ClipboardList, Search, Menu, X, Moon, Sun,
  Upload, Download, ChevronRight, ChevronDown, ChevronUp, Star, Clock, Settings,
  User, LogOut, Heart, Check, AlertCircle, Info, ExternalLink, Plus, Minus,
  MoreHorizontal, Filter, Grid, List, Home, ArrowRight, ArrowLeft, Copy,
  Share2, Bookmark, Bell, HelpCircle, Command, ImagePlus, Combine,
} from 'lucide-react';

const iconMap = {
  FileText, Image, Shield, Pencil, Zap, Layers, ArrowRightCircle, ArrowLeftCircle,
  Scissors, Trash2, FileOutput, LayoutGrid, ScanLine, Minimize2, Wrench, Eye,
  Square, FileType, Table, Presentation, Globe, Type, Sheet, Monitor, Archive,
  AlignLeft, PenTool, RotateCcw, Hash, Droplets, Crop, MessageSquare, PenLine,
  Unlock, Lock, EyeOff, GitCompare, Eraser, Maximize2, Minimize, RefreshCw,
  Sparkles, FolderPlus, Mail, Cloud, ClipboardList, Search, Menu, X, Moon, Sun,
  Upload, Download, ChevronRight, ChevronDown, ChevronUp, Star, Clock, Settings,
  User, LogOut, Heart, Check, AlertCircle, Info, ExternalLink, Plus, Minus,
  MoreHorizontal, Filter, Grid, List, Home, ArrowRight, ArrowLeft, Copy,
  Share2, Bookmark, Bell, HelpCircle, Command, ImagePlus, Combine,
};

const Icon = ({ name, size = 20, className = '', ...props }) => {
  const IconComponent = iconMap[name];
  if (!IconComponent) return <span className={className}>●</span>;
  return <IconComponent size={size} className={className} {...props} />;
};

export default Icon;
